// CALLING A MEETING OFF — which is not deleting it, and the dialog says which is which.
//
// The distinction is the whole reason this exists. A cancelled meeting stays on the
// calendar, struck through, with who cancelled it and optionally why; its slot is freed
// the moment it is cancelled, so the time is immediately bookable again. A DELETED meeting
// leaves no trace that it was ever arranged — and "the client cancelled twice" is exactly
// the kind of thing a record should still be able to say.
//
// The reason is optional. Requiring one would mean typing "ביטול" into a box to get past
// it, which records nothing and trains the habit of not reading the dialog.
import { useState } from 'react';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { TextInput } from '../../components/Form';
import { ErrorText } from '../../components/Loader';
import { meetingLabel } from './MeetingChip';

export default function CancelMeetingModal({ meeting, onClose, onCancelled }) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await onCancelled(reason.trim() || null);
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Modal title={he.calendar.cancelQuestion} onClose={onClose}>
      {/* Named at the top, so the confirmation cannot be given against the wrong meeting
          after a mis-click on the grid behind it. */}
      <div className="modal-subject">
        <strong>{meetingLabel(meeting)}</strong>
        <div className="muted small-note">{meeting.start_time}–{meeting.end_time}</div>
      </div>

      <p className="muted small-note">{he.calendar.cancelExplain}</p>

      <TextInput
        label={he.calendar.cancelReason}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={he.calendar.cancelReasonPlaceholder}
      />

      <div className="actions">
        <Button onClick={confirm} disabled={busy}>
          {busy ? he.common.loading : he.calendar.cancelConfirm}
        </Button>
        <Button variant="subtle" onClick={onClose} disabled={busy}>{he.common.cancel}</Button>
      </div>

      {error && <ErrorText error={error} />}
    </Modal>
  );
}
